module.exports = __webpack_public_path__ + "media/components/assets/img/logo/mono/visa-abeda0cb8566b23461456239c3dfeaa3.png";